import { render, staticRenderFns } from "./ManagerLayout.vue?vue&type=template&id=47701e88&"
import script from "./ManagerLayout.vue?vue&type=script&lang=js&"
export * from "./ManagerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports